import { GlLink, GlButton, GlCollapse, GlIcon, GlBadge, GlTableLite } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import Commit from '../../vue_shared/components/commit.vue?vue3';
import TimeAgoTooltip from '../../vue_shared/components/time_ago_tooltip.vue?vue3';
import DeploymentStatusLink from '../../environments/components/deployment_status_link.vue?vue3';
import DeploymentTriggerer from '../../environments/environment_details/components/deployment_triggerer.vue?vue3';
import { __ } from '~/locale';
import { InternalEvents } from '../../tracking/index.js?vue3';
import { CLICK_EXPAND_DEPLOYMENTS_ON_RELEASE_PAGE, CLICK_ENVIRONMENT_LINK_ON_RELEASE_PAGE, CLICK_DEPLOYMENT_LINK_ON_RELEASE_PAGE } from '../constants';
export default {
    name: 'ReleaseBlockDeployments',
    components: {
        GlLink,
        GlButton,
        GlCollapse,
        GlIcon,
        GlBadge,
        GlTableLite,
        TimeAgoTooltip,
        Commit,
        DeploymentStatusLink,
        DeploymentTriggerer
    },
    mixins: [
        InternalEvents.mixin()
    ],
    props: {
        deployments: {
            type: Array,
            required: true
        }
    },
    data () {
        return {
            isDeploymentsExpanded: true
        };
    },
    methods: {
        toggleDeploymentsExpansion () {
            this.isDeploymentsExpanded = !this.isDeploymentsExpanded;
            if (this.isDeploymentsExpanded) {
                this.trackEvent(CLICK_EXPAND_DEPLOYMENTS_ON_RELEASE_PAGE);
            }
        },
        trackEnvironmentLinkClick () {
            this.trackEvent(CLICK_ENVIRONMENT_LINK_ON_RELEASE_PAGE);
        },
        trackDeploymentLinkClick () {
            this.trackEvent(CLICK_DEPLOYMENT_LINK_ON_RELEASE_PAGE);
        }
    },
    tableFields: [
        {
            key: 'environment',
            label: __('Environment'),
            thClass: '!gl-border-t-0'
        },
        {
            key: 'status',
            label: __('Status'),
            thClass: '!gl-border-t-0'
        },
        {
            key: 'deploymentId',
            label: __('Deployment ID'),
            thClass: '!gl-border-t-0'
        },
        {
            key: 'commit',
            label: __('Commit'),
            thClass: '!gl-border-t-0'
        },
        {
            key: 'triggerer',
            label: __('Triggerer'),
            thClass: '!gl-border-t-0'
        },
        {
            key: 'created',
            label: __('Created'),
            tdClass: 'gl-whitespace-nowrap',
            thClass: '!gl-border-t-0'
        },
        {
            key: 'finished',
            label: __('Finished'),
            tdClass: 'gl-whitespace-nowrap',
            thClass: '!gl-border-t-0'
        }
    ]
};
